export default __webpack_public_path__ + "static/media/7.f1b0a5c9.gif";